import * as React from "react"
import styled from "styled-components"

export const ActiveItemBar = styled.div<{ color?: any; short?: boolean }>`
  height: ${(props) => (props.short ? "3px" : "6px")};
  border-radius: 3px;
  background-color: ${(props) => props.theme.colors.greyDisabled};
  background: ${(props) => (props.color ? props.color : undefined)};
  width: ${(props) => (props.short ? "44px" : "100%")};
`
